import { collection, addDoc } from 'firebase/firestore';
import { logEvent } from 'firebase/analytics';
import { db, analytics } from '../lib/firebase';
import { useAuth } from './AuthContext';
import { AnalyticsEvent } from '../types';
import { useCallback } from 'react';

export const useAnalytics = () => {
  const { user } = useAuth();

  console.log('🔍 useAnalytics hook called by component');

  const addEvent = useCallback(async (
    type: AnalyticsEvent['type'],
    data?: Partial<Pick<AnalyticsEvent, 'moduleId' | 'sectionId' | 'quizId' | 'score' | 'durationMs'>>
  ) => {
    if (!user) return;

    console.log('🔍 Analytics event being sent:', { type, data, userId: user.uid });

    try {
      const event: Omit<AnalyticsEvent, 'id'> = {
        uid: user.uid,
        type,
        ...data,
        agency: user.agency,
        responderType: user.responderType,
        ts: new Date(),
        device: navigator.userAgent.includes('Mobile') ? 'pwa' : 'web',
      };

      // Store in Firestore for detailed analytics
      await addDoc(collection(db, 'events'), event);

      // Also send to Firebase Analytics for built-in reporting
      if (analytics) {
        const eventParams: Record<string, string | number> = {
          user_role: user.role,
          responder_type: user.responderType,
          device_type: event.device,
        };

        if (data?.moduleId) eventParams.module_id = data.moduleId;
        if (data?.score !== undefined) eventParams.score = data.score;
        if (data?.durationMs) eventParams.duration_ms = data.durationMs;
        if (user.agency) eventParams.agency = user.agency;

        logEvent(analytics, type.replace('.', '_'), eventParams);
      }
    } catch (error) {
      console.error('Error logging analytics event:', error);
    }
  }, [user]);

  return { addEvent };
};